var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 40,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9598 48.3543L46.4921 38.8713C46.2485 38.2475 45.7034 37.8618 45.0771 37.8618C44.4509 37.8618 43.9174 38.2475 43.6506 38.894L40.1945 48.3543C40.0321 48.7967 40.2641 49.2845 40.7164 49.4433C41.1687 49.6021 41.6674 49.3752 41.8298 48.9328L42.5488 46.9704H47.5939L48.3129 48.9328C48.4405 49.2845 48.7768 49.5 49.1364 49.5C49.2292 49.5 49.3335 49.4887 49.4263 49.4546C49.8786 49.2958 50.1106 48.8081 49.9482 48.3657L49.9598 48.3543ZM43.1867 45.2576L45.0887 40.051L46.9908 45.2576H43.1867ZM40.2293 35.2869C37.6081 39.3364 35.2422 41.7866 32.366 43.42C32.2268 43.4994 32.076 43.5334 31.9368 43.5334C31.6353 43.5334 31.3453 43.386 31.183 43.1137C30.9394 42.7054 31.0786 42.1836 31.4961 41.9567C33.9316 40.5728 35.9265 38.5878 38.1649 35.2982H30.8698C30.3943 35.2982 30 34.9125 30 34.4475C30 33.9824 30.3943 33.5967 30.8698 33.5967H35.219V31.3507C35.219 30.8857 35.6133 30.5 36.0888 30.5C36.5643 30.5 36.9587 30.8857 36.9587 31.3507V33.5967H41.3079C41.7834 33.5967 42.1777 33.9824 42.1777 34.4475C42.1777 34.9125 41.7834 35.2982 41.3079 35.2982H40.2177L40.2293 35.2869ZM40.2757 43.5334C40.1249 43.5334 39.9741 43.4994 39.8349 43.42C39.0811 42.989 38.3504 42.5125 37.6661 42.0134C37.2834 41.7299 37.2022 41.1967 37.4922 40.8224C37.7821 40.4481 38.3272 40.3687 38.71 40.6522C39.3362 41.1173 40.0205 41.5484 40.7164 41.9454C41.1339 42.1836 41.2731 42.7054 41.0295 43.1137C40.8671 43.386 40.5772 43.5334 40.2757 43.5334Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateActive);
export default __webpack_public_path__ + "static/media/TranslateActive.f58994df99ebd14dd73ab55a7c008498.svg";
export { ForwardRef as ReactComponent };